import { Injectable } from '@angular/core';
import { FormFieldBase } from './form-field-base';
import { FormControl, FormGroup, Validators, AbstractControl } from '@angular/forms';

@Injectable()
export class FormFieldService {

  constructor() {
  }

  toFormGroup(fields: FormFieldBase<any>[]) {
    const group: { [key: string]: AbstractControl } = {};

    for (const field of fields) {
      const value = (field.value === undefined || field.value === null) ? '' : field.value;
      const validators = field.required ? [Validators.required] : [];
      group[field.key] = new FormControl(value, validators);
    }

    return new FormGroup(group);
  }

}
